import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable, of} from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class TVService {

  constructor(private http: HttpClient) {
  }

  getChannelId(event_id:any): Observable<any> {
    return this.http.get<any>(environment.base_url + "/get-tv-channel-id/"+event_id);
  }
  
  getTvUlr(data:any): Observable<any> {
    return this.http.post<any>("https://dev-api.dreamdelhi.com/api/tv-stream",data);
    // return this.http.post<any>("https://api2.dbm9.com/api/tv-stream",data);
  }
  
  getScoreData(event_id:any): Observable<any> {
    return this.http.get<any>(environment.base_url + "/get-live-score/"+event_id);
  }
}
